import Skeleton from '@components/v2/ui/Skeleton/Skeleton';
import { Stack, useTheme } from '@mui/material';
import {
  SKELETON_SURFACE_SX,
  SKELETON_TOTALS_GAP,
  SKELETON_TOTALS_LINE_HEIGHT,
  SKELETON_TOTALS_LINE_WIDTHS,
} from './orderProductItemSkeleton.constants';

const OrderProductTotalsSkeleton = () => {
  const theme = useTheme();

  return (
    <Stack aria-hidden sx={{ alignItems: 'flex-end', rowGap: `${SKELETON_TOTALS_GAP}px` }}>
      {SKELETON_TOTALS_LINE_WIDTHS.map((width, line) => (
        <Skeleton
          key={line}
          variant="rectangular"
          width={width}
          height={SKELETON_TOTALS_LINE_HEIGHT}
          sx={{ ...SKELETON_SURFACE_SX, borderRadius: `${theme.shape.borderRadiusMd}px` }}
        />
      ))}
    </Stack>
  );
};

export default OrderProductTotalsSkeleton;
